import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27e9cdd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { class: "modern-table" }
const _hoisted_6 = ["href"]

import ProdevValidator from '@/components/auth/ProdevValidator.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import BookService from '@/services/BookService';
import { onMounted,ref,Ref } from 'vue';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfView',
  setup(__props) {

const service = new BookService()
const loading:Ref<boolean> = ref(false)
const pdf:Ref<any> = ref({})

onMounted(async()=>{
    loading.value = true
    pdf.value = await service.GetBooks()
    loading.value = false
})
 



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(ProdevValidator),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_unref(main).TITLE_PDFVIEW), 1),
        _createElementVNode("h2", null, _toDisplayString(_unref(main).SUBTITLE_PDFVIEW), 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_1_PDFVIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_2_PDFVIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_3_PDFVIEW), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pdf.value, (elm) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: elm.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(elm?.category), 1),
                  _createElementVNode("td", null, _toDisplayString(elm?.author), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: elm?.pdf_uri,
                      download: "Ejercicios_Respuestas.pdf",
                      class: "link-pdf",
                      target: "_blank"
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-fileopen-round",
                        class: "ver",
                        fill: _unref(main).THIRD_COLOR,
                        scale: "3"
                      }, null, 8, ["fill"])
                    ], 8, _hoisted_6)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})